import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { JobOpening } from '../../models/job-opening.interface';

@Component({
  selector: 'app-job-sidebar',
  standalone: false,
  templateUrl: './job-sidebar.component.html',
  styleUrls: ['./job-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobSidebarComponent {
  @Input() job!: JobOpening;
  window = window;

  copyLink(): void {
    const link = window.location.href;
    navigator.clipboard.writeText(link).then(() => {
      alert('Link copied to clipboard!');
    }).catch((err: Error) => {
      console.error('Failed to copy link:', err);
    });
  }
}
